export const GAME_OVER = 'GAME_OVER';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const LOADING = 'LOADING';
export const GET_QUESTIONS = 'GET_QUESTIONS';
export const CHECK_ANSWER = 'CHECK_ANSWER';
export const GET_NEXT_QUESTION = 'GET_NEXT_QUESTION';
export const RESET = 'RESET';
